<template>
  <modal
    name="managevalidation-reason-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
    
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <div class="row">
            <div class="col-6">
              <p class="text-white txt--ss opacity--50">Manage Validations Reasons</p>
            </div>
            <div class="col-6">
              <p class="text-white txt--ss opacity--50 text-right">
                <span class="cursor-pointer" @click="openModal('manage-validation-reason-edit')"
                  > + Create Validation Reasons</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="content__divider"></div>

        <div class="content__box__body content__box__body__audit__table">
          <!-- <div class="table-responsive"> -->
           <!--  <div class="content__box__body"> -->

              <div class="">

                <div class="row mb-2">

                  <div class="col-4">
                    <p class="txt--xs txt--semi-bold opacity--50">Validation Reasons</p>
                  </div>
                  <div class="col-4">
                    <p class="txt--xs txt--semi-bold opacity--50">Status</p>
                  </div>
                  <div class="col-4">
                  </div>

                  
                </div>

                <div class="row mb-2">
                  <div class="col-4">
                    <p class="text-white txt--ss">Staff</p>
                  </div>
                  <div class="col-4">
                    <p class=" txt--ss txt--green">Active</p>
                  </div>
                  <div class="col-4">
                    <div class=" txt--ss"><span class="cursor-pointer text-white">Edit</span> <span class="cursor-pointer text-danger ml-3">Delete</span></div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-4">
                    <p class="text-white txt--ss">Staff 2</p>
                  </div>
                  <div class="col-4">
                    <p class=" txt--ss text-danger">inActive</p>
                  </div>
                  <div class="col-4">
                    <div class=" txt--ss"><span class="cursor-pointer text-white">Edit</span> <span class="cursor-pointer text-danger ml-3">Delete</span></div>
                  </div>
                </div>

                
              </div>

           <!--  </div> -->
         <!--  </div> -->
        </div>

        

      </div>

      <div class="d-flex justify-content-center flex-wrap mt-4">
          <button class="button button--primary button--sm mr-3">Save</button>
          <button class="button button--outline button--sm">Cancel</button>
        </div>

      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>

  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import Toggle from "@/components/toggle";
import axios from "../../axios";
export default {
  name: "ManageValidationReasons",
  components: {
    
  },
  props: ["childModalName"],
  data() {
    return {
      value: null,
      unlimited_validaiton: true,
      departments_list: [],
      manageValidationPagination: {
        to:         0,
        page:       1,
        total:      0,
        load_more:  true,
        infiniteId: +new Date(),
      },
      manageValidation_infiniteId: +new Date(),
    };
  },

  created() {
    // this.getValidationName();
  },
  methods: {
    closeModal() {
      this.$modal.hide("managevalidation-reason-modal");
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    }
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
input[type="text"] {
  background: transparent;
  outline: none;
  border-radius: 22px;
  border: 1px solid #535353;
}
.quantity {
  color: #848484;
  font-size: 10px;
}
</style>